import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import AdminCompetencyEdit from './AdminCompetencyEdit';
import AdminResource from './AdminResource';
import { ArcherContainer, ArcherElement } from 'react-archer'
import ReactTooltip from 'react-tooltip'
import AdminRenderCompetency from './AdminRenderCompetency';

class AdminCompetency extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
        formOpen: false,
        errorMsg: '',
    		data:{
      			'roadmapName' : '',
            'competencyName' : '',
            'roadmapId' : ''
      	},
        addData:{
          competencyName: '',
          competencyDesc: '',
          roadmapId: ''
        },
        flowchart:{
          'flowchartDetails' : []
        },
        renderFlowchart: {
          'nameOfCompetency' : '',
          'idOfCompetency' : ''
        },
        viewPage: 'initial',
        manageData:{
        'competencyDetails':[]
        }
    };
  }

  handleFormOpen = (event) => {
    this.setState({formOpen: true, errorMsg:''})
  }

  handleFormClose = (event) => {
    let default_data = Object.assign({}, this.state.addData)
    default_data.competencyName = ''
    default_data.competencyDesc = ''
    this.setState({addData: default_data, formOpen: false})
  }

  handleNameChange = (event) => {
    let data = Object.assign({}, this.state.addData)
    data.competencyName = event.target.value
    this.setState({addData: data}) 
  }

  handleDescChange = (event) => {
    let data = Object.assign({}, this.state.addData)
    data.competencyDesc = event.target.value
    this.setState({addData: data}) 
  }

  handleUnlistedCompetencyView = (competencyName, competencyId) => {
    let viewPage = Object.assign({}, this.state.viewPage)
    let renderFlowchart = Object.assign({}, this.state.renderFlowchart)
    renderFlowchart.nameOfCompetency = competencyName
    renderFlowchart.idOfCompetency = competencyId
    viewPage = 'resource_view'
    this.setState({renderFlowchart: renderFlowchart, viewPage: viewPage})
  }

  handleSubmit = (event) => {
    let data = Object.assign({}, this.state.addData)

    if ((this.state.addData.competencyName == '') || (this.state.addData.competencyDesc == '')) {
      return this.setState({ errorMsg: 'Please enter the Competency name and Competency description to add a new Competency.' })
    }
    let input = {
      'name' : this.state.addData.competencyName,
      'roadmap_id' : this.props.roadmapId,
      'description' : this.state.addData.competencyDesc
    }
    api.adminNewCompetency(this.props.user.accessToken, input)
      .then((result) => {
        if(result.status === 'success'){
          let default_data = Object.assign({}, this.state.addData)
          let manageData = Object.assign({}, this.state.manageData)
          default_data.competencyName = ''
          default_data.competencyDesc = ''
          api.adminCompetencyDisplay(this.props.user.accessToken, this.props.roadmapId)
          .then((result) => {
            manageData.competencyDetails = result.data
            this.setState({manageData: manageData})
          })
          this.setState({addData: default_data, formOpen: false , errorMsg:''})
        }
        else if(result.status == 'save_error'){
          this.setState({ errorMsg: 'Competency not saved. Please try again later.' })
        }
        else if(result.status == 'error'){
          this.setState({ errorMsg: 'A Competency with the same name for this Roadmap already exists.' })
        }
        }).catch((err) => {
          this.setState({ errorMsg: 'Error Occurred. Please Contact Admin' })
        })
  }

  handleCompetencies = (e) => {
    let viewPage = Object.assign({}, this.state.viewPage)
    viewPage = 'edit_view'
    this.setState({viewPage: viewPage})
  }

  handleMainPageReturn = (e) => {
    this.props.handleBackAction(this.props.user.accessToken)
  }

  handleCompetencyPageBackAction = (e) => {
    let viewPage = Object.assign({}, this.state.viewPage)
    viewPage = 'initial'
    this.setState({viewPage: viewPage})
    let flowchart = Object.assign({}, this.state.flowchart)
    api.adminFlowChartDisplay(this.props.user.accessToken, this.props.roadmapId)
    .then((result) => {
      flowchart.flowchartDetails = result.data
      this.setState({flowchart: flowchart})
    })
  }

  insideCompetency = (e, competencyName, competencyId) => {
    e.preventDefault()
    let viewPage = Object.assign({}, this.state.viewPage)
    let renderFlowchart = Object.assign({}, this.state.renderFlowchart)
    renderFlowchart.nameOfCompetency = competencyName
    renderFlowchart.idOfCompetency = competencyId
    viewPage = 'resource_view'
    this.setState({renderFlowchart: renderFlowchart, viewPage: viewPage})
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    let flowchart = Object.assign({}, this.state.flowchart)
    let manageData = Object.assign({}, this.state.manageData)
    data.roadmapName = this.props.roadmapName
    data.roadmapId = this.props.roadmapId
    this.setState({data: data})

    return api.adminCompetencyDisplay(this.props.user.accessToken, this.props.roadmapId)
    .then((result) => {
      manageData.competencyDetails = result.data
      this.setState({manageData: manageData})
      api.adminFlowChartDisplay(this.props.user.accessToken, this.props.roadmapId)
      .then((result) => {
        flowchart.flowchartDetails = result.data
        this.setState({flowchart: flowchart})
      })
    })
  }

  onCompetencyUpdate = (event) =>{
    let flowchart = Object.assign({}, this.state.flowchart)

    api.adminFlowChartDisplay(this.props.user.accessToken, this.props.roadmapId)
    .then((result) => {
      flowchart.flowchartDetails = result.data
      this.setState({flowchart: flowchart})
    })
  } 

	render() {
    let displayComponent
    let flowchartComponent
    let newCompetency
    let competencyComponent

    let insideCompetency = this.insideCompetency

    const rootStyle = { display: 'flex', justifyContent: 'center', border: '1px solid black',};
    const rowStyle = { margin: '200px 0', display: 'flex', justifyContent: 'space-between', }
    const boxStyle = { padding: '10px', border: '1px solid black', };

    //<span onMouseEnter={(() => hoverOn(flowchartCompName))} onMouseLeave={(() => hoverOff())}>

    if(this.state.manageData.competencyDetails.length>0){
      let handleUnlistedCompetencyView = this.handleUnlistedCompetencyView
      let onCompetencyUpdate = this.onCompetencyUpdate
      competencyComponent = (
        <Grid>
          {this.state.manageData.competencyDetails.map(function(competency){
            return(
              <AdminRenderCompetency competencyName = {competency.name} 
                competencyId = {competency.id} 
                competencyDescription = {competency.description}
                onhandleUnlistedCompetencyView = {handleUnlistedCompetencyView} 
                onCompetencyUpdate = {onCompetencyUpdate} />
            )
          })}
        </Grid>
      )
    }

    if (this.state.formOpen){
      newCompetency = (
        <GridCell span="4">
          <TextField fullwidth label ="Name of the Competency"  autoComplete="off"  name="name" value = {this.state.addData.competencyName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
          <br />
          <TextField textarea fullwidth label="Enter a short description" rows="2" value = {this.state.addData.competencyDesc} onChange = {this.handleDescChange} />
          <span>
            <Button raised style={{ width: '50%' }} onClick={this.handleSubmit}>Submit</Button>
            <Button style={{ width: '50%' }} onClick={this.handleFormClose}>Cancel</Button>
          </span>
          <StatusMessage error_msg = {this.state.errorMsg} />
        </GridCell>
      )
    }

    if(this.state.flowchart.flowchartDetails.length>0){
      let flowchart = this.state.flowchart
      flowchartComponent = (
        <div>
          <ArcherContainer strokeColor='blue'>
          {this.state.flowchart.flowchartDetails.map(function(flowchartDetail){
            let relationsTest=[{
              from: { anchor: 'bottom'},
              to: { anchor: 'top', id:flowchartDetail.child_id },
            }]
            let flowchartCompId = flowchartDetail.id
            let flowchartCompName = flowchartDetail.name
            if(flowchartDetail.child_id === undefined){
              return (
                <div> <br /> <br />
                  <ArcherElement
                    id={flowchartDetail.id}>
                    <div>
                      <Grid>
                        <GridCell span="4">
                        </GridCell>
                        <GridCell span="4">
                          <Card style={{padding: '25px'}} className='flowchart-element-color' >
                            <Typography use="headline7" align="center" color="#1483EE"> <a href="javascript:void(0)" onClick= {((e) => insideCompetency(e, flowchartCompName, flowchartCompId))} style={{cursor: 'pointer'}} data-tip={flowchartDetail.description} > {flowchartDetail.name} </a> </Typography>
                            <ReactTooltip place="right" type="dark" effect="solid"/>
                          </Card>
                        </GridCell>
                        <GridCell span="4">
                        </GridCell>
                      </Grid>
                    </div>
                  </ArcherElement> 
                </div>
              )
            }
            return (<div> <br /> <br />
                 <ArcherElement
                id={flowchartDetail.id}
                relations={relationsTest}>
                <div>
                  <Grid>
                    <GridCell span="4">
                    </GridCell>
                    <GridCell span="4">
                      <Card style={{padding: '25px'}} className='flowchart-element-color'>
                        <Typography use="headline7" align="center"> <a href="javascript:void(0)" onClick= {((e) => insideCompetency(e, flowchartCompName, flowchartCompId))} style={{cursor: 'pointer'}} data-tip={flowchartDetail.description} > {flowchartDetail.name} </a> </Typography>
                        <ReactTooltip place="right" type="dark" effect="solid"/>
                      </Card>
                    </GridCell>
                    <GridCell span="4">
                    </GridCell>
                  </Grid>
                </div>
          </ArcherElement> </div>
            )
          })} 
          </ArcherContainer>
        </div>
      )
    }

    if (this.state.viewPage == 'initial') {
      displayComponent = (
          <div>
            <Grid>
              <GridCell span="1">
                <Button raised style={{ width: '100%' }} onClick={this.handleMainPageReturn}>Back</Button>
              </GridCell>
              <GridCell span="3">
                <Button raised onClick={this.handleCompetencies}>Manage Roadmap</Button>
              </GridCell>
              <GridCell span="12">
                <Card style={{padding: '25px'}}>
                  <Typography use="headline5">{this.state.data.roadmapName}</Typography>
                </Card>
              </GridCell>
              <GridCell span="5">
                <Button onClick={this.handleFormOpen}>Add Competency</Button>
                <GridCell span="8">
                  {newCompetency}
                </GridCell>
              </GridCell>
              <GridCell span="12">
                {competencyComponent}
              </GridCell>
              <GridCell span="12">
                <Typography use="headline6" align="center">Competency Flow:</Typography>
                {flowchartComponent}
              </GridCell>
            </Grid>
          </div>
      )
    }
    else if (this.state.viewPage == 'edit_view') {
      displayComponent = (
        <AdminCompetencyEdit roadmapId = {this.state.data.roadmapId}
        roadmapName = {this.state.data.roadmapName}
        handleCompetencyPageBackAction = {this.handleCompetencyPageBackAction} />
      )
    }
    else if (this.state.viewPage == 'resource_view') {
      displayComponent = (
        <AdminResource nameOfCompetency = {this.state.renderFlowchart.nameOfCompetency}
        idOfCompetency = {this.state.renderFlowchart.idOfCompetency} 
        handleCompetencyPageBackAction = {this.handleCompetencyPageBackAction} />
      )
    }
		return (
      <div>
        {displayComponent}
      </div>
			);
	}
}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCompetency);



// WEBPACK FOOTER //
// ./src/views/admin/AdminCompetency.jsx